import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export const getBimehNamehExpireDateMaxDay = createAsyncThunk(
  'BimehNamehHayeShakhsSales/GetBimehNamehExpireDateMaxDay',
  async () => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.GetBimehNamehShakhsSalesExpireDateMaxDay}`,
    });
  }
);
